import { createMiddleware, createStart } from "@tanstack/react-start";
import { compressResponse } from "@/lib/compression";
import { isIndexableEnv, withNoindexHeader } from "@/lib/indexing";

// Cloud Run sends what the server sends, so pages, server routes and server functions are compressed here.
const compressForTheBrowser = createMiddleware().server(
  async ({ request, next }) => {
    const result = await next();
    return { ...result, response: compressResponse(request, result.response) };
  },
);

// Test/preview deploys are public, so every response tells crawlers not to index them.
const noindexOutsideProduction = createMiddleware().server(async ({ next }) => {
  const result = await next();
  if (isIndexableEnv(process.env.VITE_APP_ENV)) return result;
  return { ...result, response: withNoindexHeader(result.response) };
});

export const startInstance = createStart(() => ({
  requestMiddleware: [compressForTheBrowser, noindexOutsideProduction],
}));
